function newsletter(cbx) {
    if (cbx.checked) {
        document.getElementById("Subscribe").disabled = false;
    } else {
        document.getElementById("Subscribe").disabled = true;
    }
}
function ottieni() {
  if(!window.location.href.includes('scaffalature-industriali-su-misura')){
    return;
  }
    let altezza = document.getElementById('altezza');
    let altezzaValue = document.getElementById('altezza').value;
    let larghezza = document.getElementById('larghezza');
    let larghezzaValue = document.getElementById('larghezza').value;
    let livelli = document.getElementById('livelli');
    let livelliValue = document.getElementById('livelli').value;

    var url = `/search/suggest.json?q=Scaffalatura%20industriale%20${altezzaValue}%20X%20${larghezzaValue}%20${livelliValue}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`;

    let miodiv = document.getElementById('miodiv');

    getData(url).then((r) => {
        let img = document.getElementById('img');

        miodiv.innerHTML = "";
        ris = r['resources']['results']['products'];
        ris.forEach((e) => {
            img.setAttribute('src', e.image);
            miodiv.innerHTML +=
                `
   <div class="grid-container-res">
       <div class="grid-item-res">
           <a href=${e.url}>
               <img width="200px" class="list-view-item__image" src="${e.image}">    
           </a>
       </div>
       <div class="grid-item-res">
           <a href=${e.url}>
               <span>${e.title}</span>
           </a>
       </div>
       <div class="grid-item-res">
           <span class="price">
               €${e.price}
           </span>
           <span>Tasse escluse</span>
       </div>
   </div>
   `;
        });
    })
    .catch(err=>{console.log(err);
        miodiv.innerHTML += '<p>Se non hai trovato quello che cerchi contattaci.</p>'
    });
}

//Chiamata API GET
async function getData(url = '') {

    const response = await fetch(url, {
        method: 'GET',
        cors: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Origin': 'https://tuttologistica.it',

        },
        referrerPolicy: 'no-referrer'
    });
    return response.json();
}

document.addEventListener("DOMContentLoaded", (event) => {
    ottieni();
    let miodiv = document.getElementById('miodiv');
    if (miodiv) {

    } else {
        return;
    }

});

document.addEventListener("DOMContentLoaded", (event) => {
    /*let sped = document.querySelector('.product-form__price-info');
    if(sped){
        sped.style.display = none;
        //sped.textContent = sped.textContent.replace('costi','tempi');
    }*/
    
    let spedCart = document.querySelector('span.estimate-shipping__text');
    if(spedCart){
        spedCart.textContent = spedCart.textContent.replace('costi','tempi');
    }
    
});